/**
 * @blockdaemon-internal/portfolio-ts-client – TypeScript client for the Portfolio Monitoring API.
 * Uses Bearer token auth on every request.
 *
 * Run `npm run generate-client` first to generate the API client from the OpenAPI spec.
 */
import { Configuration } from './generated/configuration.js';
import { ChainsApiFactory } from './generated/api/chains-api.js';
import { TokensApiFactory } from './generated/api/tokens-api.js';
import { PortfolioInsightsApiFactory } from './generated/api/portfolio-insights-api.js';
import { WalletInsightsApiFactory } from './generated/api/wallet-insights-api.js';
export * from './types.js';
const DEFAULT_BASE_URL = 'https://svc.blockdaemon.com';
/**
 * Create a configured API client. Call once at app/widget init.
 * All requests include `Authorization: Bearer <token>`.
 */
export function createPortfolioClient(config) {
    const { bearerToken, baseUrl = DEFAULT_BASE_URL } = config;
    const configuration = new Configuration({
        basePath: baseUrl,
        baseOptions: {
            headers: {
                Authorization: `Bearer ${bearerToken}`,
            },
        },
    });
    const chainsApi = ChainsApiFactory(configuration);
    const tokensApi = TokensApiFactory(configuration);
    const portfolioApi = PortfolioInsightsApiFactory(configuration);
    const walletApi = WalletInsightsApiFactory(configuration);
    return {
        /** @deprecated Use the typed methods below. Kept for low-level access. */
        getConfiguration: () => configuration,
        getChains(req = {}) {
            return chainsApi.getChains(req.chainID, req.chainName, req.networkType, req.chainType, req.fiatType).then(res => res.data);
        },
        getTokens(req = {}) {
            return tokensApi.getTokens(req.chainID, req.tokenAddress, req.tokenSymbol, req.tagLimit, req.fiatType).then(res => res.data);
        },
        getTokenTags() {
            return tokensApi.getTokenTags().then(res => res.data);
        },
        getNetworkApy(req = {}) {
            return portfolioApi.portfolioV1ApyGet(req.chainIDs).then(res => res.data);
        },
        getWalletBalance(req) {
            return walletApi.getWalletBalance(req.address, req.chainIDs, req.fiatType).then(res => res.data);
        },
        getWalletTransactions(req) {
            return walletApi.getWalletTransactions(req.address, req.chainIDs, req.pageToken, req.limit, req.fiatType, req.transactionVerbosity).then(res => res.data);
        },
    };
}
export * from './generated/index.js';
